import { APPLICANT_ROLES } from 'components/flags/constants'
import FlagControlArea from 'components/flags/FlagControlArea'
import { Portal } from 'components/utility/portal'
import React, { useCallback, useEffect, useState } from 'react'

export function FlagControlAreaModal({ role, processorWorking, packageHashedId, currentRoundNumber }) {
  const [open, setOpen] = useState(false)
  const [requirementId, setRequirementId] = useState(null)
  const [title, setTitle] = useState(null)

  const handleClose = useCallback(() => {
    setOpen(false)
    setRequirementId(null)
    setTitle(null)
    document.dispatchEvent(new CustomEvent('package:flag-modal-closed'))
  }, [])

  useEffect(() => {
    const handler = (e) => {
      const { requirementId, title } = e.detail
      setRequirementId(requirementId)
      setTitle(title)
      setOpen(true)
    }
    document.addEventListener('package:requirement-flag-open', handler)
    return () => document.removeEventListener('package:requirement-flag-open', handler)
  }, [])

  useEffect(() => {
    if (!open) return
    document.body.classList.toggle('overlay-activated', open)
    return () => document.body.classList.remove('overlay-activated')
  }, [open])

  useEffect(() => {
    if (!open) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [open, handleClose])

  if (!open || !requirementId) return null

  return (
    <Portal>
      <div className="flag-icon-modal dome-d-flex dome-align-center dome-justify-center" onClick={handleClose}>
        <div className="flag-icon-modal-panel" onClick={(e) => e.stopPropagation()}>
          <FlagControlArea
            target={{ flaggableType: 'PackageRequirement', flaggableId: requirementId, packageId: packageHashedId }}
            role={role}
            title={APPLICANT_ROLES.includes(role) ? 'view flags' : 'flag requirement'}
            subtitle={title}
            processorWorking={processorWorking}
            currentRoundNumber={currentRoundNumber}
            onClose={handleClose}
            scopeRequirementId={requirementId}
          />
        </div>
      </div>
    </Portal>
  )
}

export default FlagControlAreaModal
